package org.example.zone360.components


import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.fontSize
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Res
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.flexGrow
import org.jetbrains.compose.web.css.fontFamily
import org.jetbrains.compose.web.css.minWidth
import org.jetbrains.compose.web.css.outline
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Input

@Composable
fun KeywordInput(
    keywords: MutableList<String>, // ← pass from parent
    inputValue: String,            // ← new: input box value from parent
    onInputValueChange: (String) -> Unit, // ← new: input change event to parent
    width: CSSLengthOrPercentageNumericValue = 100.percent,
    height: CSSLengthOrPercentageNumericValue = 52.px,
    isError: Boolean = false,
    onKeywordAdded: (() -> Unit)? = null
) {
    val sitePalette = ColorMode.current.toSitePalette()
    var isFocused by remember { mutableStateOf(false) }

    Column(
        modifier = Modifier.minWidth(width)
            .minHeight(height)
            .flexWrap(flexWrap = FlexWrap.Wrap)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .minHeight(height)
                .padding(topBottom = 8.px, leftRight = 15.px)
                .border(
                    1.px,
                    LineStyle.Solid,
                    if (isFocused) Colors.Green else if (isError) sitePalette.textErrorColor.rgb else sitePalette.textFieldBorderColor.rgb
                )
                .borderRadius(5.px)
                .flexWrap(flexWrap = FlexWrap.Wrap),
            verticalAlignment = Alignment.CenterVertically
        ) {
            keywords.forEach { keyword ->
                Row(
                    modifier = Modifier
                        .gap(4.px)
                        .margin(right = 4.px, bottom = 3.px)
                        .backgroundColor(sitePalette.textFieldBorderColor.rgb)
                        .borderRadius(8.px)
                        .padding(8.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    FieldTitleTextNormalSimple(keyword, fontSize = 12.px)

                    Image(
                        src = Res.Images.cross_Icon,
                        modifier = Modifier.onClick { keywords.remove(keyword) }
                            .cursor(Cursor.Pointer)
                    )
                }
            }
            Input(
                type = InputType.Text,
                attrs = {
                    value(inputValue)
                    onInput {
                        onInputValueChange(it.value)  // Update parent when typing
                    }
                    onFocus { isFocused = true }
                    onBlur { isFocused = false }
                    onKeyDown { event ->
                        if (event.key == "Enter" || event.key == ",") {
                            event.preventDefault()
                            val trimmed = inputValue.trim()
                            if (trimmed.isNotEmpty() && !keywords.contains(trimmed)) {
                                keywords.add(trimmed)
                                onInputValueChange("") // Clear input field after Enter
                                onKeywordAdded?.invoke()
                            }
                        }
                    }
                    if (keywords.isEmpty() && inputValue.isEmpty()) {
                        placeholder("Write keyword(s) and hit enter to confirm")
                    }
                    style {
                        flexGrow(1.0)
                        minWidth(0.px)
                        outline("none")
                        border(0.px)
                        backgroundColor(Colors.Transparent)
                        fontFamily(Constants.FONT_FAMILY)
                        fontSize(FontSize.Small)
                    }
                }
            )
        }
    }
}



